import React from "react"
import AllVehicleTable from "./AllVehicleTable"
import UpdateVehicleDialog from "./UpdateVehicleDialog"

const AllVehiclePage = () => {
  return (
    <>
      <AllVehicleTable />
      <UpdateVehicleDialog />
    </>
  )
}

export default AllVehiclePage
